import React, { Component } from 'react';
import { connect } from 'react-redux';
import { func } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { startSetNewsList, startSetWebmasterNewsList } from '../../actions/news';
import Card from '../../components/Card/Card';
import NewsList from '../../components/News/NewsList';

export class NewsWidget extends Component {
  static propTypes = {
    startSetNewsList: func.isRequired,
    startSetWebmasterNewsList: func.isRequired,
  };

  _mounted = false;

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      news: [],
      webmasterNews: [],
      activeTab: 1,
    };

    this.cardRef = React.createRef();
  }

  componentDidMount() {
    this._mounted = true;
    this.setState(() => ({ loading: true }));

    this.props.startSetWebmasterNewsList({ limit: 8 }).then(({ news: webmasterNews = [] }) => {
      this._mounted &&
        this.setState(
          () => ({
            loading: false,
            webmasterNews,
          }),
          () => {
            if (!webmasterNews.length) {
              // вкладка "Все" новости
              this.cardRef.current.toggle(1);
            }
          },
        );
    });

    this.props.startSetNewsList({ limit: 8 }).then(({ news }) => {
      this._mounted && this.setState(() => ({ news }));
    });
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  navItems = [
    <FormattedMessage id="news.tabs.all_news" defaultMessage="All news" />,
    <FormattedMessage id="widgets.news.tabs.for-me" defaultMessage="For me" />,
  ];

  handleTabChange = (tab) => {
    this.setState({ activeTab: tab });
  };

  render() {
    const { loading, webmasterNews, news, activeTab } = this.state;
    const { collapsing, localStorageName } = this.props;

    return (
      <Card.Tabs
        title="widgets.news.title"
        defaultMessage="News"
        navItems={this.navItems}
        panes={[<NewsList news={[]} />, <NewsList news={[]} />]}
        loading={loading}
        ref={this.cardRef}
        className="news-widget"
        localStorageName={localStorageName}
        collapsing={collapsing}
        activeTab={activeTab}
        onTabChange={this.handleTabChange}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  startSetNewsList: (params) => dispatch(startSetNewsList(params)),
  startSetWebmasterNewsList: (params) => dispatch(startSetWebmasterNewsList(params)),
});

export default connect(undefined, mapDispatchToProps)(NewsWidget);
